



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Icone extends Vue {
  @Prop() public icone: any;

  public mounted() {
    console.log(this.icone, this.iconPath);
    console.log(this.iconPath.icon.width / 15);
  }

  get iconPath() {
    return this.$store.getters["icones/getByName"](this.icone);
  }
}
